export enum VendorTypeEnum {
  CORPORATE = 'corporate'
}
